<template>
  <div class="product-aside-cart-container">
    <div class="product-aside-cart-item">
      <button
        type="button"
        data-test="personalisationButton"
        class="btn--product-aside btn--product-aside--full"
        @click="triggerPersonalisationModel"
      >
        {{ personalisationLabel }}
      </button>
    </div>
  </div>
</template>

<script>
import events from "Assets/js/components/events";
import { mapGetters } from "vuex";
import cartContent from "Templates/content/cart.json";
import engravingHelper from "Assets/js/components/helpers/engravingHelper";

export default {
  props: {
    product: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      addingToCart: false,
      product_id: this.product.shopify_id,
      requires_personalisation: false,
      personalisationlimit: 20
    };
  },
  computed: {
    ...mapGetters(["cartInstance", "isB2B"]),
    personalisationLabel() {
      return this.isB2B ? cartContent.product.add_and_personalise : cartContent.product.personalise;
    }
  },
  methods: {
    triggerPersonalisationModel() {
      if (this.isB2B) {
        this.addThisToCart(() => events.cartShow());
        return;
      }

      window.dispatchEvent(
        new CustomEvent('togglePersonalisationPreview', {})
      )

      this.cartInstance.togglePersonalisationModel(
        this.product.product_variants[0].id,
        this.product.shopify_id,
        this.product.shopify_title,
        this.product.featuredImage.src,
        this.personalisationlimit
      );
    },
    addThisToCart(callback) {
      this.addingToCart = true;
      this.cartInstance.addToCart(this.product.product_variants[0].id, 1, this.product_id, (responseData) => {
        if (responseData.status === 200) {
          this.addingToCart = false;
          events.cartChange();
          if (typeof callback === "function") callback();
        }
      });
    }
  },
  beforeMount() {
    if (this.product.shopify_metafields?.requires_personalisation) {
      this.requires_personalisation = true;
      this.personalisationlimit = parseInt(this.product.shopify_metafields.personalisation_limit) || 20;
    }
  }
};
</script>
